import React, { Component } from "react";

import './Loading.css'

export class Loading extends Component {
    render() {
        return (
            <div className="loading">
                <span className="loading__body">
                    <span className="loading__body__left"><span className="loading__mask"></span></span>
                    <span className="loading__body__right"><span className="loading__mask"></span></span>
                </span>
            </div>
        );
    }
}
    